import { HttpMethod } from '../../../http-method'
import { createAsyncApiAction } from '@cbgms/base/redux/create-async-action'
import { GetShopExternalGMS, ShopExternalGMS } from '.'

export const getShopExternalGMS = () =>
  createAsyncApiAction<GetShopExternalGMS>('gms', {
    method: HttpMethod.GET,
    url: `/modules/external-gms`
  })

export const createShopExternalGMS = (data: ShopExternalGMS) =>
  createAsyncApiAction<void>('gms', {
    method: HttpMethod.POST,
    url: `/modules/external-gms`,
    data
  })
